export default function SongTempoChange(actionContext, payload) {
	return actionContext.dispatch('SONG_SET_TEMPO', payload);
}
